import { atom } from 'recoil'

export const abTestState = atom({
  key: 'AbTestManageAbTestState',
  default: {
    IsDirty: false,
    Info: {
      ABTestID: 0,
      Nome: '',
      PercTest: 0,
      Criterio: 0,
      TempoValutazione: 0,
      TipoTest: '',
      Stato: 0,
      IdList: 0,
      TotalRecipients: 0,
      ErrorCode: '',
      Deleted: false,
      TestDateCTZScheduled: '',
      WinnerIntervalSecondsScheduled: 0,
      WinnerDateCTZScheduled: '',
      TimeZoneScheduled: '',
      CreationDate: '',
      LastModificationDate: ''
    },
    Messages: [],
    Tags: [],
    existsFailedSending: false,
    maxOpenRate: 0,
    maxClickRate: 0,
    maxAbuseRate: 0,
    testRunning: false,
    testEnded: false,
    sendingWinner: false,
    testCompleted: false,
    testStopped: false,
    winnerSendStopped: false,
    testNotStartMode: false,
    winnerMessageScheduledManualMode: false,
    idWinnerMessageManual: null,
    idWinnerMessageManualIsDirty: false,
    schedulingAutomatic: 4,
    schedulingAutomaticIsDirty: false,
    idAggregateReport: 0,
    disableStatBtn: true,
    showStopTestBtn: false,
    showStopSendWinnerBtn: false,
    showReplanBtn: false,
    showPlanBtn: false,
    startWinnerMessageDate: false,
    showInfoMessageScheduledBoxConfig: false,
    changeHistory: undefined
  }
})

export const tagsListState = atom({
  key: 'abtestManageTagsListState',
  default: {
    tagsList: []
  }
})
